/* Weekend Redneck, product card swatch behavior */
(function () {
  'use strict';

  function initCard(card) {
    if (card.dataset.pcardInit) return;
    card.dataset.pcardInit = '1';

    var img = card.querySelector('.pcard__img');
    var swatches = card.querySelectorAll('[data-swatch]');
    var colorName = card.querySelector('[data-color-name]');
    if (!img) return;
    var original = img.getAttribute('src');

    swatches.forEach(function (sw) {
      function preview() {
        var src = sw.getAttribute('data-image');
        if (src) img.setAttribute('src', src);
      }
      function apply() {
        var src = sw.getAttribute('data-image');
        if (src) { img.setAttribute('src', src); img.removeAttribute('srcset'); }
        if (colorName && sw.getAttribute('data-name')) {
          colorName.textContent = sw.getAttribute('data-name');
        }
      }
      sw.addEventListener('mouseenter', preview);
      sw.addEventListener('focus', preview);
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.removeAttribute('aria-current'); });
        sw.setAttribute('aria-current', 'true');
        apply();
      });
    });

    card.addEventListener('mouseleave', function () {
      /* Hat cards pick colors with bundle.js dots; their choice sticks */
      if (card.hasAttribute('data-bundle-card')) return;
      var current = card.querySelector('[data-swatch][aria-current="true"]');
      if (!current && original) img.setAttribute('src', original);
    });
  }

  function init() {
    document.querySelectorAll('.pcard').forEach(initCard);
    document.querySelectorAll('[data-swatch-next]').forEach(function (btn) {
      if (btn.dataset.nextInit) return;
      btn.dataset.nextInit = '1';
      btn.addEventListener('click', function () {
        var track = btn.parentElement.querySelector('.pcard__swatch-track');
        if (track) track.scrollBy({ left: 80, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
